var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radio",class:{
    'radio--disabled': _vm.disabled,
    'radio--checked': _vm.checked,
    'radio--error': _vm.error,
  }},[_c('span',{staticClass:"radio__state"}),_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }